<script lang="ts">
    export let identificativo: string;
    export let titolo: string;
    export let testo_pulsante: string = "";
    export let componente_interno;
    export let icon_class: string = "";
</script>

<label class="button" for={identificativo}>{testo_pulsante}<span class="{icon_class}"></span></label>

<input type="checkbox" id={identificativo} class="modal" />
<div role="dialog">
    <div class="card large">
        <label for={identificativo} class="modal-close" />
        <h3 class="section">{titolo}</h3>
        <div class="section row">
            <svelte:component this={componente_interno}></svelte:component>
        </div>
    </div>
</div>
